import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Returns a callback that navigates to the given app href. Used by the
 * launchpad to navigate when an app tile is clicked.
 */
export function useLaunchpadAppNavigation() {
  const navigate = useNavigate();
  return useCallback((href: string) => navigate(href), [navigate]);
}
